import {
    EXTERNAL_USER_EMAIL_ALREADY_USED_ERROR,
    EXTERNAL_USER_EMAIL_USED_ON_SOFT_ACCOUNT_ERROR,
    EXTERNAL_USER_WITHOUT_EMAIL_ERROR,
    LINK_ACCOUNTS_LOG_IN_PATH,
    SET_LINKED_SOFT_ACCOUNTS_PATH,
    SOCIAL_SIGN_UP_PATH,
} from '../../constants';

export const getSocialConfigErrors = ({ dispatchUpdateFormType }: any) => ({
    [EXTERNAL_USER_WITHOUT_EMAIL_ERROR]: ({
        socialData,
        socialProvider,
        notificationMessage,
        errorMessage,
    }: any) => {
        dispatchUpdateFormType({
            formName: SOCIAL_SIGN_UP_PATH,
            socialData,
            socialProvider,
            notificationMessage,
            errorMessage,
        });
    },
    [EXTERNAL_USER_EMAIL_ALREADY_USED_ERROR]: ({
        socialData,
        socialProvider,
        notificationMessage,
        errorMessage,
    }: any) => {
        dispatchUpdateFormType({
            formName: LINK_ACCOUNTS_LOG_IN_PATH,
            socialData,
            socialProvider,
            notificationMessage,
            errorMessage,
        });
    },
    [EXTERNAL_USER_EMAIL_USED_ON_SOFT_ACCOUNT_ERROR]: ({
        socialData,
        socialProvider,
        notificationMessage,
        errorMessage,
    }: any) => {
        dispatchUpdateFormType({
            formName: SET_LINKED_SOFT_ACCOUNTS_PATH,
            socialData,
            socialProvider,
            notificationMessage,
            errorMessage,
        });
    },
});
